import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import 'hammerjs';
import { worker } from './mocks/worker';

if (environment.production) {
  enableProdMode();
}

// msw 起動
if (environment.version.includes('MOCK')) {
  worker?.start({ onUnhandledRequest: 'bypass' });
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
